import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import _ from 'lodash';

import { getSelectOptions } from 'src/reducers/selectOptions';
import Button from 'jbc-front/components/Button';
import { FormSubmitBtn } from 'src/buttons';
import CommonModal from 'jbc-front/components/CommonModal';
import { POLICY_FORM } from 'src/constants/FormNames';
import ExtensionSelectField from 'src/components/ExtensionSelectField';
import { changeCheckedUserPolicy, getList } from 'src/reducers/users/roleUsers';
import styles from './ChangePolicyModal.scss';
import { useTranslation } from 'react-i18next';

const RawForm = ({ handleSubmit, submitting, submit, cancelBtnClick, clientRoles, numberOfUser, header }) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <CommonModal.Header hideModal={cancelBtnClick}>{header}</CommonModal.Header>
      <CommonModal.Body>
        <form onSubmit={handleSubmit}>
          <div className={styles.lead}>{t('features.RoleUsers.containers.ChangePolicyModal.change_the_authority_of')}{numberOfUser}{t('features.RoleUsers.containers.ChangePolicyModal.selected_account_as_follows')}</div>
          <div className={styles.selectWrap}>
            <ExtensionSelectField name="clientRoleId" label={t('features.RoleUsers.containers.ChangePolicyModal.authority')} options={clientRoles} required />
          </div>
        </form>
      </CommonModal.Body>
      <CommonModal.Footer>
        <Button onClick={cancelBtnClick} className="u-mr20">
          {t('features.RoleUsers.containers.ChangePolicyModal.cancel')}
        </Button>
        <FormSubmitBtn text={t('features.RoleUsers.containers.ChangePolicyModal.change')} {...{ submitting, submit }} />
      </CommonModal.Footer>
    </React.Fragment>
  );
};

let PolicyForm = reduxForm({
  form: POLICY_FORM
})(RawForm);

const mapStateToProps = state => ({
  clientRoles: getSelectOptions(state, 'clientRoles'),
  numberOfUser: _.get(_.filter(getList(state), { checked: true }), 'length')
});
const mapDispatchToProp = (dispatch, ownProps) => ({
  onSubmit: data => dispatch(changeCheckedUserPolicy(data, ownProps))
});

PolicyForm = connect(mapStateToProps, mapDispatchToProp)(PolicyForm);

const ChangePolicyModal = ({ isOpen, hideModal }) => {
  const { t } = useTranslation();
  const header = t('features.RoleUsers.containers.ChangePolicyModal.change_the_authority_of_accounts_in_bulk');
  return (
    <CommonModal ariaHideApp={false} {...{ isOpen, hideModal }}>
      <PolicyForm cancelBtnClick={hideModal} header={header} />
    </CommonModal>
  );
};

export default connect()(ChangePolicyModal);
